import { render, staticRenderFns } from "./SidebarEditQuestion.vue?vue&type=template&id=7cc75b40&scoped=true"
import script from "./SidebarEditQuestion.vue?vue&type=script&lang=js"
export * from "./SidebarEditQuestion.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditQuestion.vue?vue&type=style&index=0&id=7cc75b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc75b40",
  null
  
)

export default component.exports